import { ISendLocationInputModel } from 'inputModels';
import api from '../services/api/axios';

const sendLocaion = async (input: ISendLocationInputModel) =>
  new Promise<string>((resolve, reject) => {
    api
      .post(`/locationmap`, input)
      .then(({ data }) => resolve(data))
      .catch(() => reject());
  });
  

export const LocationMap = {
  sendLocaion
};
